import Entity from '../entity'

export default class Dealer extends Entity<number>{
    zone_id: number;
    type_id: number;
    department_id: number;
    province_id: number;
    district_id: number;
    code: number;
    code2: string;
    name: string;
    business_name: string;
    document: string;
    address_sales: string;
    address: string;
    phone1: string;
    phone2: string;
    photo_facade: string;
    photo: string;
    location: string;
    description: string;
    email: string;
    lat: number;
    lng: number;
    active: boolean;
    daily_active: number;
    ubigeo: any;
}


